import React, { Component, Fragment } from 'react';
import Loading from '../../Loading'
import FilterBar from '../../Common/FilterBar';
import extensionAPI from '../../../flowtrace-api/extensionAPI';
import UsageComponent from './usageComponent';

class MeetingOverview extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, searchWarning:null, queryFilters: { range_type: "calendar", range_period:"week", range_limit: 4} };
  }


  async loadMeetingStatistics(queryFilters) {
    this.setState({ searchWarning:null});


    const [usage] = await Promise.all([
      extensionAPI.usage(queryFilters, this.props.flowtraceUser),
    ]);


    const dataSet = {

    };

    Object.keys(usage).filter(k => k!== "histogram").forEach(k => {
      dataSet[k] = {
        histogram:  usage.histogram.map(h => ({data: h.data, values: h[k]})),
        total: usage[k]
      }
    })

    return this.setState({loading: false, ...dataSet});
  }

  onChange(queryFilters) {
    this.setState({ loading: true, queryFilters });
    this.loadMeetingStatistics(queryFilters);
  }

  componentDidMount() {
    this.loadMeetingStatistics(this.state.queryFilters);
  }

  componentWillUnmount() { this.setState = () => { return; }; }

  render() {
    if(this.state.loading)
      return (
        <Fragment>
          <FilterBar teamFilter loading={this.state.loading} flowtraceUser={ this.props.flowtraceUser } queryFilters={{...this.state.queryFilters }} onChange={this.onChange.bind(this)} />
          <Loading text={"This feature requires Google or Outlook integration. Please inquire your account manager for more details."}/>
        </Fragment>);

    return (
      <Fragment>
        <FilterBar teamFilter loading={this.state.loading} flowtraceUser={ this.props.flowtraceUser } queryFilters={{...this.state.queryFilters }} onChange={this.onChange.bind(this)} />
        <UsageComponent title="Activity" histogram={this.state.event.histogram} total={this.state.event.total} />
        <UsageComponent title="Usage Timezone" histogram={this.state.timezone.histogram} total={this.state.timezone.total} />
        <UsageComponent title="Usage City" histogram={this.state.city.histogram} total={this.state.city.total} />
        <UsageComponent title="Usage Country" histogram={this.state.country.histogram} total={this.state.country.total} />
        <UsageComponent title="Flowtrace App Version" histogram={this.state.addinVersion.histogram} total={this.state.addinVersion.total} />
        <UsageComponent title="Calendar Version" histogram={this.state.outlookVersion.histogram} total={this.state.outlookVersion.total} />
        <UsageComponent title="App Type" histogram={this.state.source.histogram} total={this.state.source.total} />
      </Fragment>
    );
  } // end of render()
} // end of class

export default MeetingOverview
